var _path, _path2, _path3, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnectIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 30,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41797 10.6299C6.10012 7.59727 9.80077 1.62988 15.0533 1.62988C20.3058 1.62988 21.9993 3.50286 23.7451 6.00656",
    stroke: "#2D3B67",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7441 19.1943L28.7441 25.1943L24.7441 28.1943V16.1943L28.7441 19.1943L20.7441 25.1943",
    stroke: "#39AC8A",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0595 10.2578C12.1478 10.4206 10.3754 11.2353 10.3244 13.1883C10.2633 15.5326 13.7493 19.0491 14.6284 21.2958C15.5075 23.5425 15.0191 26.1799 14.134 27.8405C12.52 30.8686 9.26133 30.5203 8.18143 30.0871C6.23321 29.3057 4.07284 25.6915 4.2682 19.4399C4.46356 13.1883 5.14641 11.1369 5.14641 11.1369",
    stroke: "#2D3B67",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.7441,
    cy: 9.62988,
    r: 3.5,
    stroke: "#2D3B67"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.745,
    cy: 9.62988,
    r: 1.5,
    stroke: "#2D3B67"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectIcon1);
export default __webpack_public_path__ + "static/media/connectIcon(1).3a1aacdc994fdcf1b1952c5f56c1ff26.svg";
export { ForwardRef as ReactComponent };